import { ASSETS_URL } from "config";

const getImageUrl = (url: string): string => {
  return `${ASSETS_URL}/static-ppe2/${url}`;
};

export default getImageUrl;
